import { Trophy } from "lucide-react";
import { initials, avatarColor, timeAgo } from "./common";
export function TopPosts({ posts = [] }) {
  if (!posts.length) return null;
  return (
    <div className="mb-8 p-4 rounded-2xl bg-primary/5 border border-primary/20">
      <div className="flex items-center gap-2 mb-3 text-xs font-mono uppercase tracking-wider text-primary font-semibold">
        <Trophy className="w-4 h-4" /> Top posts this week
      </div>
      <div className="space-y-2">
        {posts.map((p, i) => {
          const author = p.author || p.name || "Anonymous";
          return (
            <div key={p.id} className="flex items-center gap-3">
              <span className="text-xs text-muted-foreground w-4 shrink-0 font-mono">{i + 1}</span>
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-white text-[9px] font-semibold shrink-0" style={{ background: avatarColor(author) }}>{initials(author)}</div>
              <p className="text-sm text-foreground truncate flex-1">{p.title}</p>
              <span className="text-xs text-muted-foreground shrink-0">♥ {p.likes}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
